// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiRequest {
    static getAttributeTypeMap() {
        return MedicalBiRequest.attributeTypeMap;
    }
}
MedicalBiRequest.discriminator = undefined;
MedicalBiRequest.additionalProperties = false;
MedicalBiRequest.attributeTypeMap = [
    {
        "name": "quickPathCaseId",
        "baseName": "quickPathCaseId",
        "type": "number"
    },
    {
        "name": "preferredSpecialtyPharmacy",
        "baseName": "preferredSpecialtyPharmacy",
        "type": "boolean"
    },
    {
        "name": "specialtyPharmacyName",
        "baseName": "specialtyPharmacyName",
        "type": "string"
    },
    {
        "name": "diagnosis",
        "baseName": "diagnosis",
        "type": "MedicalBiDiagnosis"
    },
    {
        "name": "facility",
        "baseName": "facility",
        "type": "MedicalBiFacility"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "MedicalBiPatient"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "MedicalBiPayor"
    },
    {
        "name": "practice",
        "baseName": "practice",
        "type": "MedicalBiPractice"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "MedicalBiPrescriber"
    },
    {
        "name": "prescription",
        "baseName": "prescription",
        "type": "MedicalBiPrescription"
    },
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalBiRequest.js.map